import { Typography } from '@mui/material'
import { FieldValues, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import DialogRoot, { DialogProps } from 'components/Dialog'
import { CommonFormContextProps, SaveButton } from 'components/Form'
import { GamSetupOrderSlice } from '../../hooks/useGetGamSetupOrders'

type Props = Pick<CommonFormContextProps, 'formId'> &
  Pick<DialogProps, 'isOpen' | 'setOpen'> & {
    gamSetupOrder?: GamSetupOrderSlice
  }

export const Dialog = <Schema extends FieldValues>({
  formId,
  gamSetupOrder,
  isOpen,
  setOpen,
}: Props): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupPrebidStack.form.dialog',
  })
  const {
    formState: { isLoading, isValid },
  } = useFormContext<Schema>()
  const mode = gamSetupOrder ? 'update' : 'create'

  const Content: React.JSX.Element = <Typography>{t('description')}</Typography>

  const Actions: React.JSX.Element = (
    <SaveButton
      {...{
        formId,
        loading: isLoading,
        touched: true,
        valid: isValid,
      }}
      text={t('confirm')}
    />
  )

  return (
    <DialogRoot
      actions={Actions}
      content={Content}
      isOpen={isOpen}
      setOpen={setOpen}
      title={t(`title.${mode}`)}
    />
  )
}
